module.exports = __webpack_public_path__ + "static/media/b06.16849616.png";